// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes szh-menu-show-zoom {
  from {
    opacity: 0.1;
    transform: scale(0.95);
  }
}
@keyframes szh-menu-hide-zoom {
  to {
    opacity: 0.1;
    transform: scale(0.95);
  }
}
.szh-menu--state-opening {
  animation: szh-menu-show-zoom 0.125s ease-out;
}

.szh-menu--state-closing {
  animation: szh-menu-hide-zoom 0.125s ease-in forwards;
}

.szh-menu--dir-left.szh-menu--align-start {
  transform-origin: right top;
}

.szh-menu--dir-left.szh-menu--align-center {
  transform-origin: right center;
}

.szh-menu--dir-left.szh-menu--align-end {
  transform-origin: right bottom;
}

.szh-menu--dir-right.szh-menu--align-start {
  transform-origin: left top;
}

.szh-menu--dir-right.szh-menu--align-center {
  transform-origin: left center;
}

.szh-menu--dir-right.szh-menu--align-end {
  transform-origin: left bottom;
}

.szh-menu--dir-top.szh-menu--align-start {
  transform-origin: left bottom;
}

.szh-menu--dir-top.szh-menu--align-center {
  transform-origin: center bottom;
}

.szh-menu--dir-top.szh-menu--align-end {
  transform-origin: right bottom;
}

.szh-menu--dir-bottom.szh-menu--align-start {
  transform-origin: left top;
}

.szh-menu--dir-bottom.szh-menu--align-center {
  transform-origin: center top;
}

.szh-menu--dir-bottom.szh-menu--align-end {
  transform-origin: right top;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@szhsin/react-menu/dist/transitions/zoom.css"],"names":[],"mappings":"AAAA;EACE;IACE,YAAY;IACZ,sBAAsB;EACxB;AACF;AACA;EACE;IACE,YAAY;IACZ,sBAAsB;EACxB;AACF;AACA;EACE,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":["@keyframes szh-menu-show-zoom {\n  from {\n    opacity: 0.1;\n    transform: scale(0.95);\n  }\n}\n@keyframes szh-menu-hide-zoom {\n  to {\n    opacity: 0.1;\n    transform: scale(0.95);\n  }\n}\n.szh-menu--state-opening {\n  animation: szh-menu-show-zoom 0.125s ease-out;\n}\n\n.szh-menu--state-closing {\n  animation: szh-menu-hide-zoom 0.125s ease-in forwards;\n}\n\n.szh-menu--dir-left.szh-menu--align-start {\n  transform-origin: right top;\n}\n\n.szh-menu--dir-left.szh-menu--align-center {\n  transform-origin: right center;\n}\n\n.szh-menu--dir-left.szh-menu--align-end {\n  transform-origin: right bottom;\n}\n\n.szh-menu--dir-right.szh-menu--align-start {\n  transform-origin: left top;\n}\n\n.szh-menu--dir-right.szh-menu--align-center {\n  transform-origin: left center;\n}\n\n.szh-menu--dir-right.szh-menu--align-end {\n  transform-origin: left bottom;\n}\n\n.szh-menu--dir-top.szh-menu--align-start {\n  transform-origin: left bottom;\n}\n\n.szh-menu--dir-top.szh-menu--align-center {\n  transform-origin: center bottom;\n}\n\n.szh-menu--dir-top.szh-menu--align-end {\n  transform-origin: right bottom;\n}\n\n.szh-menu--dir-bottom.szh-menu--align-start {\n  transform-origin: left top;\n}\n\n.szh-menu--dir-bottom.szh-menu--align-center {\n  transform-origin: center top;\n}\n\n.szh-menu--dir-bottom.szh-menu--align-end {\n  transform-origin: right top;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
